var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stroke",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#252525;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.41,7.4v0.7v4.76v6.7c-1.46-0.3-3.04,0.12-4.17,1.25c-1.8,1.8-1.8,4.71,0,6.51c1.8,1.8,4.71,1.8,6.51,0 c0.89-0.89,1.34-2.06,1.35-3.22h0v-12l12.38-2.55v6.64c-1.46-0.3-3.04,0.12-4.17,1.25c-1.8,1.8-1.8,4.71,0,6.51 c1.8,1.8,4.71,1.8,6.51,0c0.89-0.89,1.34-2.06,1.35-3.22h0V8.79V5.81V3.33L8.41,7.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicIcon);
export default __webpack_public_path__ + "static/media/MusicIcon.3f116bedd686c8f65252316fb2a32aae.svg";
export { ForwardRef as ReactComponent };